/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export class CustomerContactDto {
  public id: string = undefined;
  public email: string = undefined;
  public name: string = undefined;
  public active: boolean;
  public hasInvitation: boolean;
  public phoneNumber: string = undefined;
  public initials: string = undefined;
  public isDefault: boolean;

  //<custom-body>
  public constructor(source: CustomerContactDto) {
    Object.assign(this, source);
  }

  public get selectItemName(): string {
    if (this.active)
      return this.name;

    return `${this.name} (inaktiv)`;
  }
  //</custom-body>
}
